import { render } from "./Beacons.vue?vue&type=template&id=57f5d288"
import script from "./Beacons.vue?vue&type=script&lang=js"
export * from "./Beacons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__